import React from 'react';
import ChangeTerm from './change-term';
import './tools.scss';

const Tools = props => {
    return (
        <ul className="report-tools">
            <li>
                <strong>
                    {props.period && props.period.name} {props.period && props.period.year}
                    {props.estimated &&
                        <span className="report-tools__estimated">Skattad</span>
                    }
                </strong> 
                <ChangeTerm onChange={props.onChange}>
                    <option>Byt period</option>
                    {props.periods.map(period => {
                        return (
                            <option key={period.id} value={period.id}>{period.name} {period.year}{period.estimated && ' (Skattad)'}</option>
                        );
                    })}
                </ChangeTerm>
            </li>
            <li><strong>Gren: </strong><span>{props.branch && props.branch.name}</span></li>
            <li><strong>Företag: </strong>{props.company && props.company.name}</li>
            <li><strong>Enhet: </strong><span>{props.unit && props.unit.name}</span></li>
        </ul>
    );
};

export default Tools;